import React, { useEffect, useState, useMemo, useRef } from "react";

//design imports from material
import {
  Grid,
  FormLabel,
  TextField,
  Typography,
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  Breadcrumbs,
  Tooltip,
} from "@mui/material";

//layout import
import Layout from "../../../layout/Layout";

//form imports
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
//date picker

import DataTable from "react-data-table-component";
import EditLocationOutlinedIcon from "@mui/icons-material/EditLocationOutlined";

import axios from "axios";
import {
  config,
  labourWagesAPI,
  statusMasterAPI,
  userData,
} from "../../../config";
import { AlertMessage } from "../../../components/AlertMessage";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";

import { useNavigate } from "react-router-dom";
import { _getDropdownListData } from "../../../service";
import moment from "moment";
import Link from "@mui/material/Link";
import { Tooltip as ReactTooltip } from "react-tooltip";
import NavigationGuard from "../../../layout/NavigationGuard";

import { MaterialReactTable } from "material-react-table";

function LabourWages() {
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    intLabourType: Yup.string().required("Labour Type is required"),
    txtLabourName: Yup.string().required("Labour Name is required"),
    intFullDayAmount: Yup.string().required("Full day Amount is required"),
    intHalfDayAmount: Yup.string().required("Half day Amount is required"),
    intMobileNumber: Yup.string().required(
      "^[0-9]{10}$",
      "Please Enter Valid Mobile Number"
    ),
  });

  const [labourList, setLabourList] = React.useState([]);

  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, reset, formState, setValue } =
    useForm(formOptions);
  const { errors } = formState;

  const [labourTypesList, setLabourTypesList] = React.useState([]);

  useEffect(() => {
    let labourData = {
      requestData: {
        intType: 4,
        intParentId: 46,
      },
      API: statusMasterAPI,
      setData: setLabourTypesList,
    };
    _getDropdownListData(labourData);
  }, []);

  function onSubmit(data) {
    data.intType = 1;
    config.method = "POST";
    data.intUserID = userData.emp_id;
    data.createdAt = moment().format("YYYY-MM-DD HH:mm:ss");
    config.data = JSON.stringify(data);
    config.url = labourWagesAPI;

    axios(config)
      .then(function (response) {
        handleFormReset();
        childRef.current.triggerAlert(
          JSON.stringify({
            message: response.data.message,
            messageType: response.data.messageType,
          })
        );
        setTimeout(function () {
          window.location.reload(true);
        }, 2000);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    handleFormReset();
  }, []);

  const handleFormReset = () => {
    let defaultValues = {};
    reset({ ...defaultValues });
  };

  const statusStyle = {};

  const handleEditRole = (id) => {
    navigate(`/config/labour-wages/edit/${id}`);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "labour_type_name",
        header: "Labour type",
        size: 150,
      },
      {
        accessorKey: "labour_name",
        header: "Labour name",
        size: 150,
      },
      {
        accessorKey: "full_day_amount",
        header: "Full day amount",
        size: 150,
        Cell: ({ cell }) => (
          <Typography>
            {cell.getValue() ? `₹${cell.getValue()}` : "-"}
          </Typography>
        ),
      },
      {
        accessorKey: "half_day_amount",
        header: "Half day amount",
        size: 150,
        Cell: ({ cell }) => (
          <Typography>
            {cell.getValue() ? `₹${cell.getValue()}` : "-"}
          </Typography>
        ),
      },
      {
        accessorKey: "mobile_number",
        header: "Mobile number",
        size: 150,
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 120,
        Cell: ({ cell }) => {
          const status = cell.getValue();
          return (
            <>
              {status == 2 ? (
                <Typography
                  className="active-status"
                  style={{ ...statusStyle, textAlign: "center" }}
                >
                  Active
                </Typography>
              ) : status == 3 ? (
                <Typography
                  className="inactive-status"
                  style={{ ...statusStyle, textAlign: "center" }}
                >
                  Inactive
                </Typography>
              ) : null}
            </>
          );
        },
      },
      {
        header: "Action",
        size: 80,
        Cell: ({ row }) => (
          <Tooltip title="Edit labour" arrow>
            <IconButton
              color="success"
              onClick={() => handleEditRole(row.original.id)}
              aria-label="edit labour"
            >
              <EditLocationOutlinedIcon />
            </IconButton>
          </Tooltip>
        ),
      },
    ],
    []
  );

  let tempRefs = useRef(false);

  const [rowsPerPage, setRowsPerPage] = React.useState(10); //change to 10 after you remove paginationRowsPerPageOptions
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalCount, setTotalCount] = useState(10);

  // const [labourList, setLabourList] = React.useState([])

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async (page, rowsPerPage) => {
    const data = JSON.stringify({
      intLimit: rowsPerPage ? rowsPerPage : 10,
      intOffset: rowsPerPage ? (page - 1) * rowsPerPage : 0,
      intType: 2,
    });

    config.method = "POST";
    config.data = data;
    config.url = labourWagesAPI;

    axios(config)
      .then(function (response) {
        setLabourList(response.data["result"]);
        setTotalCount(response.data["totalCount"]);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handlePageChange = (page) => {
    fetchUsers(page, rowsPerPage);
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = async (newRowsPerPage) => {
    if (!labourList.length) return;

    fetchUsers(1, newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  const childRef = useRef();

  return (
    <Layout>
      <Grid className="employee-form bold-header">
        <AlertMessage ref={childRef} />
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Manage Labour Wages
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">Invoice</Typography>
              <Typography color="text.primary">create</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid
            textAlign="right"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <LoadingButton
              size="medium"
              variant="contained"
              color="primary"
              onClick={() => navigate(-1)}
              startIcon={<ArrowBackIosIcon />}
            >
              Back
            </LoadingButton>
          </Grid>
        </Grid>

        <form className="form_design" onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <FormControl
                fullWidth
                error={errors.intLabourType ? true : false}
              >
                <InputLabel id="demo-simple-select-label">
                  Labour Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  label="Labour Type"
                  id="demo-simple-select"
                  {...register("intLabourType")}
                >
                  {labourTypesList.map((row) => (
                    <MenuItem key={row.id} value={row.id}>
                      {row.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText className="invalid-feedback">
                  {errors.intLabourType?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                type="text"
                fullWidth
                label="Labour Name"
                error={errors.txtLabourName ? true : false}
                {...register("txtLabourName")}
                helperText={errors.txtLabourName?.message}
              />
            </Grid>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                type="number"
                fullWidth
                label="Full Day Amount"
                error={errors.intFullDayAmount ? true : false}
                {...register("intFullDayAmount")}
                helperText={errors.intFullDayAmount?.message}
              />
            </Grid>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                type="number"
                fullWidth
                label="Half Day Amount"
                error={errors.intHalfDayAmount ? true : false}
                {...register("intHalfDayAmount")}
                helperText={errors.intHalfDayAmount?.message}
              />
            </Grid>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                type="text"
                fullWidth
                label="Mobile Number"
                error={errors.intMobileNumber ? true : false}
                {...register("intMobileNumber")}
                helperText={errors.intMobileNumber?.message}
              />
            </Grid>
          </Grid>
          <div className="empty-space-20"></div>
          <Grid
            item
            className="form-lable"
            xs={12}
            lg={12}
            md={12}
            marginTop="20px"
            textAlign="right"
          >
            <Button className={`btn-primary`} type="submit">
              Submit
            </Button>
          </Grid>
        </form>
        <div className="empty-space-20"></div>
        <Grid className="small_table">
          <MaterialReactTable
            columns={columns}
            enableGlobalFilter={false}
            // enableColumnActions={false}
            enableFullScreenToggle={false}
            enableDensityToggle={false}
            data={labourList}
            state={{
              pagination: {
                pageIndex: currentPage - 1, // MRT uses zero-based index
                pageSize: rowsPerPage,
              },
            }}
            manualPagination
            rowCount={totalCount}
            onPaginationChange={(updater) => {
              const newPagination =
                typeof updater === "function"
                  ? updater({
                      pageIndex: currentPage - 1,
                      pageSize: rowsPerPage,
                    })
                  : updater;
              handlePageChange(newPagination.pageIndex + 1); // convert back to one-based
              handleRowsPerPageChange(newPagination.pageSize);
            }}
            enableStickyHeader
            muiTableContainerProps={{
              sx: { maxHeight: "550px" },
            }}
            muiTableHeadCellProps={{
              sx: {
                "& input": {
                  color: "#fff !important",
                  "&::placeholder": {
                    color: "#fff !important",
                    opacity: 1,
                  },
                },
                "& .MuiSelect-select": {
                  color: "#fff !important", // selected text color
                },
                "& .MuiSelect-icon": {
                  color: "#fff !important", // dropdown arrow color
                },
                color: "#fff",
                fontWeight: "bold",
                "& svg": {
                  color: "#fff",
                },
                "& .MuiTableSortLabel-root": {
                  color: "#495057",
                  "&.Mui-active": {
                    color: "#fff",
                    "& .MuiTableSortLabel-icon": {
                      color: "#fff !important",
                    },
                  },
                },
                "& .MuiTableSortLabel-icon": {
                  color: "#fff !important",
                },
              },
            }}
            muiTablePaperProps={{
              sx: {
                height: "100%",
                display: "flex",
                flexDirection: "column",
                width: "100%",
              },
            }}
            initialState={{
              density: "compact",
            }}
            muiTableBodyRowProps={({ row }) => ({
              sx: {
                cursor: "pointer",
              },
            })}
            pageCount={Math.ceil(totalCount / rowsPerPage)}
            muiTablePaginationProps={{
              rowsPerPageOptions: [1, 10, 25, 50, 100],
              showFirstButton: true,
              showLastButton: true,
            }}
          />
        </Grid>
      </Grid>
      <>
        <NavigationGuard />
      </>
    </Layout>
  );
}

export default LabourWages;
